import { fetchFromAPI } from '../../helper/helpers';
import { API } from '../../helper/endpoints';

export default {
  async submitQuery(context, payload) {
    const response = await fetchFromAPI(API.CONTACT_QUERY, {
      body: {
        userName: payload.name,
        userEmail: payload.youremail,
        contactNumber: payload.contactnumber,
        message: payload.message,
        consent: payload.consent,
      },
    });

    if (!response.success) {
      context.commit('contactLinkSuccess', {
        contactLinkSuccess: {
          success: false,
          message: response.error.error_message,
        },
      });
      return response.success;
    }
    context.commit('contactLinkSuccess', {
      contactLinkSuccess: {
        success: true,
        message: response.data.success_message,
      },
    });

    return response.success;
  },
};
